import React, { useState } from "react";
import { getData } from "../../../serverRequest";
import LoadingSpinner from "../../../components/Loadder";
import moment from 'moment';
import { Link } from 'react-router-dom';

// components
import EntityListTable from "../../../components/Tables/EntityListTable.js";


export default function EntityList() {
    const [open, setOpen] = React.useState(true);
    const [totalEntities, setTotalEntities] = React.useState([]);
    const [isSuperadmin, setSuperadmin] = React.useState(JSON.parse(localStorage.getItem('companyAdmin')));
    const [loading, setLoading] = useState(true);
    const searchParams = new URLSearchParams(window.location.search);
    
    const ticketFilter = searchParams.get('filter');
    //console.log(ticketFilter);
    const toggleDrawer = () => {
      setOpen(!open);
    };
  
    const formatDate = (dateString) => {
      return moment(dateString).format('DD/MM/YYYY');
    };
  
    const filterEntityData = (entities_data) => {
      //console.log(tickets_data);
      let totalEntity = [];
      if(entities_data){
        for (let i = 0; i < entities_data.length; i++) {
            totalEntity.push(entities_data[i])
        }
      }
     
      setTotalEntities(totalEntity);
      return ({ "total": totalEntity })
    }
    React.useEffect(() => {
      async function fetchData() {
        let resData = await getData('/api/company?admin=1')
        let entities_data = resData['data']['entities']
        console.log(entities_data);
        let entitiesData = await filterEntityData(entities_data)
  
       
        setLoading(false);
      }
      fetchData();
  
  
    }, [])
    return (
        <>

            <main>
                <div className="relative block py-24 lg:pt-0 px-4">
                    <div className="rounded-t bg-white mb-0 px-6 py-6">
                        <div className="text-center flex justify-between">
                            <h6 className="text-blueGray-700 text-xl font-bold">Entities</h6>
                            {isSuperadmin ? (<>
                            <Link to="/admin/entityForm">
                            <button
                                className="bg-lightBlue-500 text-white active:bg-lightBlue-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150"
                                type="button">
                             Entity
                            </button>
                            </Link>
                            </>) : ''}
                        </div>
                    </div>
                    {loading ? (
                        <LoadingSpinner></LoadingSpinner>
                    ) : (<>
                        <div
                            className={
                                "relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded " +
                                ("light" === "light" ? "bg-white" : "bg-lightBlue-900 text-white")
                            }
                        >

                            <div className="block w-full overflow-x-auto py-24 lg:pt-0 px-4">
                                {/* Projects table */}
                                <EntityListTable totalEntities={totalEntities} isSuperadmin={isSuperadmin}></EntityListTable>

                            </div>
                        </div>
                    </>)}
                </div>
            </main>

        </>
    );
}
